export default __webpack_public_path__ + "static/media/rocket_anim_153.63a9cc02.png";